var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"url-box"},[_c('span',{staticClass:"url com-hand",on:{"click":_vm.openUrl}},[_vm._v(_vm._s(_vm.text||_vm.url))]),(_vm.copy)?_c('span',{staticClass:"copy com-hand",on:{"click":_vm.copyFun}},[_vm._v("复制")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }